import {GeneralRedirect, IRoutesProvider} from 'Shared/Routes';
import { lazy } from 'solid-js';


export class VenueRoutes implements IRoutesProvider
{
	constructor(
		private customPages
	)
	{ }

	routes()
	{
//TODO add redirect route for all trailing /s here. Currently a hack is fixed in Server.resolveRoute()

		return ([
			...this.frontend(),
			...this.backend(),

			//TODO want a frontend page not found page. Doing this prevents '/logout' (and probably other routes from reaching the server router though).
			//     Could possibly render and call the page not found page directly from the Server.ts file
			// '/*':	[new FrontendPageNotFound(this.inBrowser,this.urls,this.times),() => ({}) ],
		]);
	}

	frontend()
	{
		return ([
			{
				path: '/staffResources',
				component: lazy(() => import('Shared/frontend/staffResources/StaffResourcePage')),
			},
			{
				path: '/',
				component: lazy(() => import('Shared/frontend/layouts/StandardLayout')),
				children: this.frontendContent()
			},
		]); 
	}

	frontendContent()
	{
		let ret = [
			{
				path: '/',
				component: lazy(() => import('Shared/frontend/homePage/HomePage')),
			},
			{
				path: '/menu',
				component: lazy(() => import('Shared/frontend/menuPage/MenuPage')),
			},
			{
				path: '/events',
				component: lazy(() => import('Shared/frontend/eventsPage/EventsPage')),
			},
			{
				path: '/event/:slug',
				component: lazy(() => import('Shared/frontend/eventPage/EventPage')),
			},
			{
				path: '/event/:slug/artist',
				component: lazy(() => import('Shared/frontend/eventPage/ArtistAgreementPage')),
			},
			{
				path: '/contact',
				component: lazy(() => import('Shared/frontend/contactPage/ContactPage')),
			},
			{
				path: '/hire',
				component: lazy(() => import('Shared/frontend/hirePage/HirePage')),
			},
		];

		for (const page of this.customPages) 
			ret = [...ret, {
					path: page.frontend.route,
					component: lazy(() => import('Shared/frontend/CustomPage'))
				}
			];

		return ret;
	}

	backend()
	{
		return ([
			{
				path: '/login',
				component: () => <GeneralRedirect url='/admin'/>,
			},
			{
				path: '/admin',
				component: lazy(() => import('Shared/backend/BackendWrap')),

				children: [
					{
						path: '/',
						component: lazy(() => import('Shared/backend/DashboardPage')),
					},
					{
						path: [
							'/home',
							'/home/:tab',
						],
						component: lazy(() => import('Shared/backend/homePage/HomePage')),
					},

					...this.backendEvent(),

					...this.backendMenus(),

					...this.backendSpecials(),

					{
						path: [
							'/hire',
							'/hire/:tab',
						],
						component: lazy(() => import('Shared/backend/hire/HirePage')),
					},
					{
						path: [
							'/contact',
							'/contact/:tab',
						],
						component: lazy(() => import('Shared/backend/contact/ContactPage')),
					},
					{
						path: '/staffResources',
						component: lazy(() => import('Shared/backend/staffResources/StaffResourcesPage')),
					},
					{
						path: '/staffResource/:id',
						component: lazy(() => import('Shared/backend/staffResources/StaffResourcePage')),
					},
					{
						path: '/settings',
						component: lazy(() => import('Shared/backend/settingsPage/SettingsPage')),
					},
					{
						//TODO return 404
						path: '*',
						component: lazy(() => import('Shared/backend/PageNotFoundPage')),
					}
				]
			}
		]); 
	}

	backendSpecials()
	{
		return [
			{
				path: '/specials',
				component: lazy(() => import('Shared/backend/specials/SpecialsPage')),
			},
			{
				path: '/special/:id',
				component: lazy(() => import('Shared/backend/specials/SpecialPage')),
			},
		];
	}

	backendEvent()
	{
		return [
			{
				path: '/events',
				component: lazy(() => import('Shared/backend/eventsPage/EventsPage')),
			},
			{
				path: [
					'/event/:slug',
					'/event/:slug/:topTab',
					'/event/:slug/:topTab/:secondTab',
					'/event/:slug/:topTab/:secondTab/:thirdTab'
				],
				component: lazy(() => import('Shared/backend/eventPage/EventPage')),
			}
		];
	}

	backendMenus()
	{
		return [
			{
				path: '/listMenu/:slug',
				component: lazy(() => import('Shared/backend/menu/ListMenuPage')),
			},
			{
				path: '/menus',
				component: lazy(() => import('Shared/backend/menu/MenusPage')),
			},
			{
				path: '/menu-designer',
				component: lazy(() => import('Shared/backend/menu/MenuDesignerPage')),
			},
			{
				path: [
					'/menus/:slug',
					'/menus/:slug/*sectionIds',
				],
				component: lazy(() => import('Shared/backend/menu/SectionPage')),
			},
			{
				path: '/menu-item/:slug/*sectionIds',
				component: lazy(() => import('Shared/backend/menu/MenuItemPage')),
			},
		];
	}
}

export function extractMenuSectionIds(sectionsIds?:string)
{
	if (!sectionsIds)
		return [];

	const parts = [];
	for (const bit of sectionsIds.split('/')) {
		const segments = bit.split('-');
		parts.push({name:segments[0],index:Number(segments[1])});
	}
	return parts;
}

